<h1 class="titulo mb-3">Localização da vaga</h1>
<mat-divider class="mb-8"></mat-divider>
<endereco-form [disabled]="view" (fieldChange)="enderecoChange($event)" [isCadastro]="false" [isCreatVaga]="true" [empresaEspecial]="empresaEspecial"
    [oldEndereco]="oldEndereco" class="mb-9"></endereco-form>
<h1 class="titulo mb-3">Dados da vaga</h1>
<mat-divider class="mb-8"></mat-divider>
<div class="row">
    <div class="form-group">
        <label class="form-label required" for="name">Titulo da vaga</label>
        <input required type="text" class="form-control" name="name" id="name" maxlength="256" [disabled]="view"
            placeholder="Vaga Disponivel para Designer" [(ngModel)]="vaga.tituloVaga" #nameModel="ngModel"
            #nameInput="ngModel" (change)="changeInput()"/>

        <abp-validation-summary [control]="nameModel"></abp-validation-summary>
    </div>
</div>
<div class="row mb-5">
    <div class="col-12 col-md-5 mr-5">
        <div class="form-group">
            <label class="form-label" [ngClass]="{'required': !empresaEspecial}" for="name">Nome do cargo</label>
            <filterable-select [disabled]="view" [options]="cargos" optionLabel="nome"
                placeholder="Ex: Serviços gerais, administrativo, assistente" [(selected)]="cargo"
                (onInputChanged)="onCargoDigitado($event)" class="filterable-custom"></filterable-select>
        </div>
    </div>
    <div class="col-12 col-md-6">
        <div class="row">
            <div class="col-6">
                <label class="form-label" for="name">Vagas exclusivas para PcD?</label>
                <custom-toggle [disabled]="view" [(value)]="vaga.pcd"
                    (toggleChange)="onSelectPcD($event)"></custom-toggle>
            </div>
            <div class="col-6">
                <label class="form-label" for="name">É uma vaga confidencial?</label>
                <custom-toggle [disabled]="view" [(value)]="vaga.confidencial"
                    (toggleChange)="onSelectConfidencial($event)"></custom-toggle>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="form-group">
        <label class="form-label" [ngClass]="{'required': !empresaEspecial}" for="name">Modelo de trabalho:</label>
        <select-box-custom [disabled]="view" *ngIf="listaModeloTrabalho && listaModeloTrabalho.length > 0"
            [manterIndex]="true" [listaModeloTrabalho]="listaModeloTrabalho"
            (selectedOptionChange)="onSelectModeloTrabalho($event)"
            [selectedOption]="modeloTrabalho"></select-box-custom>
    </div>
</div>
<div class="row">
    <div class="col-6">
        <div class="form-group">
            <label class="form-label" [ngClass]="{'required': !empresaEspecial}" for="regimeTrabalho">Regime de trabalho:</label>
            <input-select-text [disabled]="view" *ngIf="regimesTrabalho && regimesTrabalho.length > 0" [valores]="regimesTrabalho"
                maxlength="128" [placeholder]="'Selecione um regime'" [selectValor]="selectedRegimeTrabalho"
                (selectedOptionChange)="onSelectOrTypeRegimeTrabalho($event)">
            </input-select-text>
        </div>

    </div>
    <div class="col-6">
        <div class="form-group">
            <label class="form-label" [ngClass]="{'required': !empresaEspecial}" for="horasSemanais">Qual a quantidade de horas semanais?</label>
            <input required type="text" class="form-control" name="horasSemanais" id="horasSemanais" maxlength="256"
                [disabled]="view" placeholder="0" [(ngModel)]="vaga.horasSemanais"
                (keypress)="validateNumberInput($event)" #horasSemanaisModel="ngModel" (change)="changeInput()"/>
            <abp-validation-summary [control]="horasSemanaisModel"></abp-validation-summary>
        </div>
    </div>
</div>
<div *ngIf="empresaEspecial" class="row">
    <div class="form-group">
        <label class="form-label" [ngClass]="{'required': empresaEspecial}" for="urlVaga">Url da vaga</label>
        <input type="text" class="form-control" name="urlVaga" id="urlVaga" maxlength="256" [(ngModel)]="vaga.urlVaga" (change)="changeInput()"
            placeholder="www.exemplo.com.br" [disabled]="view" #urlVagaModel="ngModel" #urlVagaEl pattern="^(https?):\/\/[^\s]+$" />
    </div>
    <div *ngIf="urlVagaModel.errors?.pattern">
        <p class="text-danger">
            A URL fornecida não é válida. Use um formato como: http://www.exemplo.com
        </p>
    </div>
</div>
<div class="row">
    <div class="col-6">
        <div class="form-group">
            <label class="form-label" [ngClass]="{'required': !empresaEspecial}" for="salario">Qual o valor do salário?</label>
            <input type="text" class="form-control" name="valorSalario" id="valorSalario" maxlength="256"
                [disabled]="view" [(ngModel)]="vaga.salario" #valorSalarioModel="ngModel" #valorSalarioEl
                placeholder="R$0,00" currencyMask
                [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left' }" autocomplete="off"
                (ngModelChange)="validarSalario()" />

            <abp-validation-summary [control]="valorSalarioModel"></abp-validation-summary>

            <div class="row mt-5" *ngIf="salarioInvalido">
                <p class="aviso">O valor do salário não pode exceder R$900.000. Por favor, insira um valor
                    válido.</p>
            </div>
        </div>
    </div>
    <div class="col-6">
        <div class="form-group">
            <label class="form-label" [ngClass]="{'required': !empresaEspecial}" for="quantidadeVagas">Quantidade de vagas?</label>
            <input required type="text" class="form-control" name="quantidadeVagas" id="quantidadeVagas" placeholder="1"
                [disabled]="view" [(ngModel)]="vaga.quantidadeVagas" (keypress)="validateNumberInput($event)"
                #quantidadeVagasModel="ngModel" (change)="changeInput()" />

            <abp-validation-summary [control]="quantidadeVagasModel"></abp-validation-summary>
        </div>
    </div>
</div>
<div class="row mb-10">
    <div class="col-6">
        <label class="form-label" for="name">Deseja exibir salário em vaga?</label>
        <custom-toggle [disabled]="view" [(value)]="vaga.exibirSalario"
            (toggleChange)="onSelectExibirSalario($event)"></custom-toggle>
    </div>
    <div class="col-6">
        <label class="form-label" for="name">Deseja exibir a quantidade de vagas?</label>
        <custom-toggle [disabled]="view" [(value)]="vaga.exibirVagas"
            (toggleChange)="onSelectExibirVaga($event)"></custom-toggle>
    </div>
</div>
<h1 class="titulo mb-3" [ngClass]="{'required': !empresaEspecial}">Descrição da vaga</h1>
<mat-divider class="mb-8"></mat-divider>
<div class="row mb-10">
    <div class="col">
        <ckeditor (change)="changeInput()" [disabled]="view" *ngIf="Editor && config" [editor]="Editor" [config]="config" [(ngModel)]="texto">
        </ckeditor>
    </div>
</div>
